// import CompScroll from "./CompScroll";
import { Link } from "react-router-dom/cjs/react-router-dom";
import newsDatas from "../assets/dummy/DataNews.json"; 
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "react-responsive";

function MainNews() {
  let [newss, setNews] = useState([]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  useEffect(() => {
    if(!newsDatas){
      return
    }

    const newsData = newsDatas.News;
    let temp = [];
    for (let i = newsData.length - 1; newsData.length - 7 < i; i--) {
      temp.push(newsData[i]);
    }
    setNews(temp);

  }, []);

  //창 열기
  const onLink = (url) => {
    window.open(url);
  };

  return (
    <>
      <div className="news">
        <div className="section-txt-wrap">
          <h2 className="section-title">새소식</h2>
          <div className="section-content">
            <p>최근 헬리오센의 다양하고 소식과</p>
            <p>이야기들을 전해드립니다.</p>
          </div>
          <Link className="link-fit" to="/promotion/news">
            <button className="section-btn-wrap">
              <span className="section-btn-more">자세히 보기</span>
              <span className="section-btn"></span>
            </button>
          </Link>
        </div>

        <div className="news-slider">
          <div className="news-slider-list">
            {pc ? (
              <Swiper slidesPerView={"auto"} spaceBetween={60}>
                {newss.map((news) => (
                  <SwiperSlide key={news.id}>
                    <div
                      className="news-slider-item"
                      onClick={() => onLink(news.url)}
                    >
                      {/* {console.log(news)} */}
                      <img
                        className="news-slider-img"
                        src={news.img}
                        alt="news"
                      />
                      <h3 className="news-title">
                        {news.title.split("\n").map((idx) => {
                          return (
                            <span className="txt" key={idx}>
                              {idx}
                            </span>
                          );
                        })}
                      </h3>
                      <span className="news-slider-txt">
                        <span>{news.date}</span>
                        <span>{news.source}</span>
                      </span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <Swiper slidesPerView={"auto"} spaceBetween={30}>
                {newss.map((news) => (
                  <SwiperSlide key={news.id}>
                    <div
                      className="news-slider-item"
                      onClick={() => onLink(news.url)}
                    >
                      {/* {console.log(news)} */}
                      <img
                        className="news-slider-img"
                        src={news.img}
                        alt="news"
                      />
                      <h3 className="news-title">
                        {news.title.split("\n").map((idx) => {
                          return (
                            <span className="txt" key={idx}>
                              {idx}
                            </span>
                          );
                        })}
                      </h3>
                      <span className="news-slider-txt">
                        <span>{news.date}</span>
                        <span>{news.source}</span>
                      </span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MainNews;
